<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }" [template]="customLoadingTemplate"></ngx-loading>
<ngx-loading [show]="loadingDivisas$ | async" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="container-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
			<div class="row">
			<div class="col-lg-9 col-12">
				<div class="row mb-4">
					<div class="col-12">
						<div class="facturador-header d-flex justify-content-between align-items-center flex-wrap">
							<div class="facturador-header__titulo">
								<h4 class="mb-0 font-weight-bold text-dark">{{ tituloFormulario }}</h4>
								<ng-container *ngIf="!(loadingFoliosSummary$ | async); else foliosLoadingTpl">
									<span class="text-muted font-size-sm" *ngIf="currentGrupoFolio; else sinFoliosTpl"> Folios disponibles: {{ currentGrupoFolio.suma }} </span>
									<ng-template #sinFoliosTpl>
										<span class="text-muted font-size-sm">Sin folios disponibles</span>
									</ng-template>
								</ng-container>
								<ng-template #foliosLoadingTpl>
									<span class="text-muted font-size-sm"><span class="spinner spinner-primary spinner-sm mr-2"></span>Consultando folios...</span>
								</ng-template>
							</div>
							<div class="facturador-header__acciones">
								<button id="boton_emision_frecuente" type="button" class="btn btn-outline-primary mr-2" (click)="abrirModalEmisionFrecuente()">
									<i class="fa-solid fa-copy"></i>
									Emisión Frecuente
								</button>
								<button *ngIf="mostrarBotonFacturarGuias" id="boton_facturar_guias" type="button" class="btn btn-warning" (click)="consultaGuiasFacturablesCliente()">Facturar Guías</button>
							</div>
						</div>
					</div>
				</div>
				<!-- fin encabezado del facturador -->
				<!-- detalles cliente -->
				<div class="row">
					<div class="col-12">
						<app-buscador-cliente id="tour-cliente" [fromExistente]="dteExistente" (clientForInvoice)="addClientToInvoiceRequest($event)" (proveedorForInvoice)="addProveedorToInvoiceRequest($event)" (clienteInternacionalFOrInvoice)="addClientToInvoiceRequest($event)"></app-buscador-cliente>
					</div>
				</div>
				<!-- fin detalles cliente -->
				<!-- card colapsable con pestañas: Referencias / Transporte / Observaciones -->
				<div class="row mt-5">
					<div class="col-12">
						<app-panel-complementario id="tour-panel-complementario" #panelComplementario [showTransporte]="showTransporte" [showExportacion]="showInExportInvoice" [showOpciones]="true" [showTipoNota]="invoiceType == InvoiceType.NotaCredito || invoiceType == InvoiceType.NotaDebito" [showComisiones]="invoiceType == InvoiceType.LiquidacionFactura"></app-panel-complementario>
						<div class="card card-custom panel-complementario-body" [hidden]="!panelComplementario.expanded">
							<div class="card-body">
								<div [hidden]="panelComplementario.activeTab !== 'tipo'" *ngIf="invoiceType == InvoiceType.NotaCredito || invoiceType == InvoiceType.NotaDebito">
									<app-nota-tipo-correccion [motivoSeleccionado]="motivoNota" [codigoTipoDte]="codigoTipoDte" [notaForm]="notaForm" (motivoSeleccionadoChange)="onMotivoChange($event)" [tipoNota]="tipoNota" (tipoNotaSeleccionado)="onTipoNotaSeleccionado($event)"></app-nota-tipo-correccion>
								</div>
								<div [hidden]="panelComplementario.activeTab !== 'referencias'">
									<app-opciones-referencias-dte #opcionesRef [fromExistente]="dteExistente" [cargandoDivisas]="loadingDivisas$ | async" [errorDivisas]="errorDivisas" (reintentarDivisas)="cargarDivisas(true)"> </app-opciones-referencias-dte>
								</div>
								<div [hidden]="panelComplementario.activeTab !== 'comisiones'" *ngIf="invoiceType == InvoiceType.LiquidacionFactura">
									<app-lista-item-detalle-comision></app-lista-item-detalle-comision>
								</div>
								<div [hidden]="panelComplementario.activeTab !== 'transporte'" *ngIf="showInExportInvoice">
									<app-exportacion-dte (indicadorServicioChange)="onIndicadorServicioExport($event)" [estadoExportacion]="currentExportacionState" [indicadorServicioInicial]="indicadorServicioExportacion"></app-exportacion-dte>
								</div>
								<div [hidden]="panelComplementario.activeTab !== 'transporte'" *ngIf="showTransporte && !showInExportInvoice">
									<app-item-transporte-dte [invoiceType]="invoiceType" (loadingChange)="loading = $event"></app-item-transporte-dte>
								</div>
								<div [hidden]="panelComplementario.activeTab !== 'observaciones'">
									<app-observaciones-dte [initialObservaciones]="observacionesDte" (observacionesChange)="onObservacionesChange($event)"></app-observaciones-dte>
								</div>
								<div [hidden]="panelComplementario.activeTab !== 'opciones'">
									<app-opciones-adicionales-dte id="tour-opciones-adicionales"
										[showCredEC]="resumenRef?.showCredEC"
										[showIvaTerceros]="resumenRef?.showIvaTerceros"
										[showMonedaButton]="opcionesRef?.showingCurrencyOptions"
										[tipoPago]="tipoPago"
										[credECTemplate]="resumenRef?.credECTemplate"
										[ivaTercerosTemplate]="resumenRef?.ivaTercerosTemplate"
										(monedaClick)="abrirModalMoneda()"
										(tipoPagoChange)="onTipoPagoChange($event)">
									</app-opciones-adicionales-dte>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- fin card colapsable con pestañas -->

				<!-- lista de detalles -->
				<div class="row mt-5">
					<div class="col-12">
						<app-lista-item-detalle-dte id="tour-detalle-productos" [fromExistente]="dteExistente" [disableDetailFields]="disableDetailFields" [hideExentoColumn]="showInExportInvoice" [ivaCheckboxTemplate]="opcionesRef?.ivaCheckboxTemplate" [dtePagadoTemplate]="opcionesRef?.dtePagadoTemplate"></app-lista-item-detalle-dte>
					</div>
				</div>
				<!-- fin lista de detalles -->
			</div>
			<!-- resumen lista detalles: columna derecha fija al hacer scroll -->
			<div class="col-lg-3 col-12">
				<div id="tour-resumen-documento" class="facturador-sidebar">
					<app-resumen-lista-detalles #resumenRef [fromExistente]="dteExistente"></app-resumen-lista-detalles>
				</div>
			</div>
			</div>
			</div>
		</div>
	</div>
</div>
<swal #currentSwal title="Operación" text="Operación realizada" icon="info" style="z-index: 900000 !important"></swal>
<ng-template #GuidesListToInvoices let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Guias de Despacho a facturar</div>
				<div class="modal-wizard-desc">Esta es la lista de guias de despacho del cliente seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<ngx-datatable #tableGuides class="material" [rows]="listaGuiasFacturables" [columnMode]="'flex'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="70" fxFlex="auto" [perfectScrollbar]="configScroll" [selectionType]="'checkbox'" [selected]="selectedGuides" (selected)="onSelect($event)" [messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
				<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
					<ng-template ngx-datatable-header-template let-value="value">
						<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[0]" (change)="selectAll($event)" />
					</ng-template>
					<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
						<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Folio" [flexGrow]="4" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ row.folio }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="Monto" [flexGrow]="4" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ row.total | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="Fecha" [flexGrow]="4" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ row.fecha | date : "dd/MM/yyyy" }}</span></ng-template
					>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
		<div class="modal-body pt-0">
			<div class="custom-control custom-checkbox">
				<input id="incluirReferenciasGuiasIndividual" type="checkbox" class="custom-control-input" [(ngModel)]="incluirDocumentosReferenciadosGuias" />
				<label class="custom-control-label" for="incluirReferenciasGuiasIndividual">Incluir documentos referenciados por las guías</label>
				<small class="form-text text-muted ml-4">Al activar esta opción, la factura también incluirá las referencias de los documentos asociados a las guías seleccionadas, como por ejemplo Órdenes de Compra.</small>
			</div>
		</div>
		<div class="modal-footer">
			<div class="form-group position-relative has-icon-left mb-0">
				<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" (click)="processGuidesIntoInvoice()">
					<i class="la la-paper-plane-o d-lg-none"></i>
					<span class="d-none d-lg-block">Enviar</span>
				</button>
				<button type="button" class="btn btn-secondary ml-3" (click)="c('Cross click')">
					<span class="d-none d-lg-block">Cerrar</span>
				</button>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #EmisionFrecuenteModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Emisión Frecuente</div>
				<div class="modal-wizard-desc">Seleccione una plantilla para autorrellenar el documento, o elimine las que ya no necesite.</div>
			</div>
		</div>
		<div class="modal-body">
			<ngx-datatable class="material" [rows]="plantillas" [columnMode]="'flex'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="60" fxFlex="auto" [messages]="{ emptyMessage: 'No hay plantillas guardadas para este tipo de documento' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
				<ngx-datatable-column name="Nombre" [flexGrow]="3" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ row.nombrePlantilla }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="Tipo DTE" [flexGrow]="2" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ nombreTipoDtePlantilla(row.codigoTipoDte) }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="Fecha creación" [flexGrow]="2" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ row.fechaCreacion | date : "dd/MM/yyyy" }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="Usuario creador" [flexGrow]="2" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row"
						><span>{{ row.nombreUsuarioCreador || "-" }}</span></ng-template
					>
				</ngx-datatable-column>
				<ngx-datatable-column name="Acciones" [flexGrow]="2" [sortable]="false" [resizeable]="false">
					<ng-template ngx-datatable-cell-template let-row="row">
						<button type="button" class="btn btn-sm btn-primary mr-1" title="Usar esta plantilla" (click)="onPlantillaSeleccionada(row)">
							<i class="fa-solid fa-copy"></i>
						</button>
						<button type="button" class="btn btn-sm btn-danger" title="Eliminar plantilla" (click)="eliminarPlantilla(row)">
							<i class="flaticon-delete"></i>
						</button>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="c('Cross click')">
				<span>Cerrar</span>
			</button>
		</div>
	</div>
</ng-template>

<ng-template #MonedaModal let-d="dismiss" let-c="close">
	<div class="modal-md">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Moneda</div>
				<div class="modal-wizard-desc">Seleccione la moneda del documento. CLP es la opción por defecto.</div>
			</div>
		</div>
		<div class="modal-body">
			<ng-container *ngTemplateOutlet="opcionesRef?.monedaTemplate"></ng-container>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="c('Cross click')">
				<span>Cerrar</span>
			</button>
		</div>
	</div>
</ng-template>
